import { render, staticRenderFns } from "./FGLGCacheTable.vue?vue&type=template&id=0c40eee7&lang=pug&"
import script from "./FGLGCacheTable.vue?vue&type=script&lang=js&"
export * from "./FGLGCacheTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports